<template>
    <div class="card policy-chart-card h-100">
        <div class="card-header pb-0">
            <div class="row align-items-center g-2">
                <div class="col-sm-6">
                    <h6 class="mb-0">{{ $t("policyRecentRequests") }}</h6>
                </div>
                <div class="col-sm-6 text-sm-end">
                    <soft-button color="success" size="sm" variant="outline" @click="goToRequests">{{ $t("commonViewAll") }}</soft-button>
                </div>
            </div>
        </div>
        <div class="card-body policy-chart-body policy-request-list pb-5">
            <ul class="list-group">
                <li v-for="data in dataTable" :key="data" class="list-group-item border-0 d-flex 
                justify-content-between mb-2 border-radius-lg pe-3">
                    <div class="d-flex flex-column me-2">
                        <a class="table-link mb-1 text-truncate" @click="info(data)">
                            {{ data.insuredName }}
                        </a>
                        <span class="text-xs text-muted d-flex align-items-center gap-2 mt-1">
                            <span>{{ data.requestDateStr }}</span>
                            <span class="badge" :class="operTypeBadgeClass(data.operType)">{{ data.operTypeName }}</span>
                        </span>
                    </div>
                    <div class="d-flex align-items-center text-sm flex-shrink-0">
                        <RequestStatusBadge :row="data" />
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { getPolicyId, insuredUrl, requestUrl } from "@/project/Source/routes";
import RequestStatusBadge from "@/project/Global/Components/RequestStatusBadge.vue";

import SoftButton from "@/components/SoftButton.vue";
export default {
    name: "RequestTable",
    components: {
        SoftButton,
        RequestStatusBadge,
    },
    props: {
        dataTable: {
            type: Array,
            default: () => []
        },
        maxHeight: {
            type: String,
            default: '510'
        }
    },
    data() {
        return {
            errorId: null,
            alert: false,
            alertColor: 'success'
        }
    },
    methods: {
        getDate(val) {
            const str = String(val)
            return str.slice(0, -9)
        },
        info(row) {
            this.$router.push(insuredUrl(row.cardId, getPolicyId(this.$route)));
        },
        goToRequests(){
            this.$router.push(requestUrl(getPolicyId(this.$route)));
        },
        operTypeBadgeClass(type) {
            if (type === 1) return "badge--info";
            if (type === 2) return "badge--danger";
            if (type === 3) return "badge--warning";
            return "badge--muted";
        },
    }
};
</script>
<style scoped>
::-webkit-scrollbar {
  width: 0;
}
.badge--info {
  background: color-mix(in srgb, var(--bs-info) 18%, transparent);
  color: var(--bs-info);
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.75rem;
}
.badge--warning {
  background: rgba(245, 158, 11, 0.15);
  color: #d97706;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.75rem;
}
.badge--success {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.75rem;
}
.badge--danger {
  background: rgba(220, 38, 38, 0.15);
  color: #dc2626;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.75rem;
}
.badge--muted {
  background: rgba(120, 130, 145, 0.15);
  color: var(--app-text);
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.75rem;
}
</style>